import { useCallback } from 'react';

import { useNavigation } from '@react-navigation/native';

import useHardwareBackPressHandler from './useHardwareBackPressHandler';

const useNavigateBackOnHardwareBackPress = (): void => {
    const navigation = useNavigation();

    const handleGoBack = useCallback(() => {
        navigation.goBack();
    }, [navigation]);

    useHardwareBackPressHandler(handleGoBack);
};

export default useNavigateBackOnHardwareBackPress;
